"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var React = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

require("./style.css");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var sizes = {
  xs: 8,
  sm: 16,
  md: 24,
  lg: 32
};

function DisksGreenMultitoneFilled(_ref) {
  var className = _ref.className,
      inheritFontColor = _ref.inheritFontColor,
      inheritFontSize = _ref.inheritFontSize,
      size = _ref.size,
      width = _ref.width,
      height = _ref.height,
      disabled = _ref.disabled,
      onClick = _ref.onClick,
      muted = _ref.muted,
      clickable = _ref.clickable,
      children = _ref.children,
      props = _objectWithoutProperties(_ref, ["className", "inheritFontColor", "inheritFontSize", "size", "width", "height", "disabled", "onClick", "muted", "clickable", "children"]);

  var classes = ['orion-icons-svg-base'];

  if (inheritFontColor) {
    classes.push('orion-icons-svg-current-clr');
  }

  if (muted) {
    classes.push('orion-icons-svg-muted');
  }

  if (!disabled && (clickable || typeof onClick === 'function')) {
    classes.push('orion-icons-svg-clickable');
  }

  if (disabled) {
    classes.push('orion-icons-svg-disabled');
  }

  classes.push(className);
  var finalWidth = width || sizes[size];
  var finalHeight = height || sizes[size];

  if (inheritFontSize) {
    finalWidth = finalHeight = '1em';
  }

  var finalClass = classes.filter(Boolean).join(' ');
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: finalWidth,
    height: finalHeight,
    fill: "none",
    viewBox: "0 0 16 16",
    color: "currentColor",
    className: finalClass,
    onClick: !disabled ? onClick : null
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: "#FF730E",
    d: "M5.982 8.01L2.833 9.058l-.35 1.05c-.116.583-.35 2.099-.35 3.498 0 1.75 3.5 1.4 5.248 2.1 1.4.559 4.782-.934 6.298-1.75v-2.45l.35-1.748-2.8-1.75-2.448-.35-2.8.35z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FF730E",
    d: "M13.38 9.94c0 1.073-2.41 1.944-5.383 1.944-2.972 0-5.382-.87-5.382-1.945 0-1.074 2.41-1.945 5.382-1.945 2.973 0 5.382.87 5.382 1.945z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M10.555 9.868c0 .418-1.145.757-2.558.757-1.413 0-2.558-.34-2.558-.757 0-.418 1.145-.757 2.558-.757 1.413 0 2.558.339 2.558.757z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M14.216 10.005c0-1.73-3.661-2.695-6.196-2.695-2.535 0-6.236.965-6.236 2.695v3.3c0 1.166 1.608 1.98 3.498 2.343v-.282c-1.036.026.363.483.805.483l1.85.15 2.656-.31c.443 0 0 .119 0-.323v.322c1.308-.201 2.482-.778 3.086-1.381.322-.322.35-.338.35-.7l.187-3.602zM7.98 8.115c2.856 0 5.391 1.045 5.391 1.89s-2.535 1.891-5.391 1.891c-2.857-.04-5.391-1.086-5.391-1.89 0-.846 2.534-1.892 5.39-1.892zm-5.391 3.178c1.207.885 3.58 1.408 5.39 1.408 1.811 0 4.185-.483 5.392-1.408v2.011c0 .845-2.535 1.891-5.391 1.891-2.857 0-5.391-1.046-5.391-1.89v-2.012zm7.2 4.073H6.087v.483a11.43 11.43 0 003.702 0v-.483zm3.89-1.41s.175-.2.014 0c-.805.806-2.16 1.692-4.212 1.692 0 0-1.71-.292-1.75-.292-2.896 0-5.247-.204-5.247-1.05l.105.286C3.796 15.477 6.169 16 7.979 16c1.811 0 4.185-.483 5.392-1.408l.308-.635z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M10.556 9.868c0 .404-1.146.731-2.559.731-1.413 0-2.558-.327-2.558-.73 0-.405 1.145-.732 2.558-.732 1.413 0 2.559.327 2.559.731z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FF9549",
    d: "M5.982.7L2.833 1.75l-.35 1.049c-.116.583-.35 2.099-.35 3.498 0 1.75 3.5 1.4 5.248 2.1 1.4.56 4.782-.934 6.298-1.75V4.198l.35-1.75L11.229.7 8.782.35 5.98.7z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M14.216 2.696C14.216.966 10.555 0 8.02 0 5.485 0 1.784.966 1.784 2.696v3.299c0 1.167 1.608 1.981 3.498 2.343v-.282c-1.036.026.363.484.805.484l1.85.15 2.656-.311c.443 0 0 .12 0-.323v.323c1.308-.202 2.482-.778 3.086-1.382.322-.322.35-.338.35-.7l.187-3.601zM7.98.805c2.856 0 5.391 1.046 5.391 1.89 0 .846-2.535 1.892-5.391 1.892-2.857-.04-5.391-1.087-5.391-1.891 0-.845 2.534-1.891 5.39-1.891zM2.589 3.983c1.207.885 3.58 1.408 5.39 1.408 1.811 0 4.185-.483 5.392-1.408v2.012c0 .845-2.535 1.89-5.391 1.89-2.857 0-5.391-1.045-5.391-1.89V3.983zm7.2 4.073H6.087v.484c1.247.2 2.495.2 3.702 0v-.484zm3.89-1.409s.175-.201.014 0c-.805.805-2.16 1.691-4.212 1.691 0 0-1.71-.291-1.75-.291-2.896 0-5.247-.205-5.247-1.05l.105.285c1.207.885 3.58 1.408 5.39 1.408 1.811 0 4.185-.482 5.392-1.408l.308-.635z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FF9549",
    d: "M13.38 2.697c0 1.035-2.41 1.874-5.383 1.874-2.972 0-5.382-.839-5.382-1.874 0-1.035 2.41-1.874 5.382-1.874 2.973 0 5.382.839 5.382 1.874z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M10.555 2.697c0 .418-1.145.757-2.558.757-1.413 0-2.558-.339-2.558-.757s1.145-.757 2.558-.757c1.413 0 2.558.339 2.558.757z"
  }));
}

DisksGreenMultitoneFilled.propTypes = {
  size: _propTypes["default"].string,
  width: _propTypes["default"].number,
  height: _propTypes["default"].number,
  className: _propTypes["default"].string,
  inheritFontColor: _propTypes["default"].bool,
  inheritFontSize: _propTypes["default"].bool,
  disabled: _propTypes["default"].bool,
  onClick: _propTypes["default"].func,
  clickable: _propTypes["default"].bool,
  muted: _propTypes["default"].bool
};
DisksGreenMultitoneFilled.defaultProps = {
  size: 'sm',
  className: '',
  inheritFontColor: false,
  inheritFontSize: false,
  disabled: false,
  onClick: null,
  clickable: false,
  muted: true
};
var _default = DisksGreenMultitoneFilled;
exports["default"] = _default;